import { Briefcase, Code } from "lucide-react";
import { useStore } from "ra-core";

import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";

import { BriefDailyBanner, type DailyBriefAudience } from "./BriefDailyBanner";
import { HomeGreet } from "./HomeGreet";
import { TodayCommercialView } from "./TodayCommercialView";
import { TodayDevView } from "./TodayDevView";

// Sprint 4 T4.3 — Page racine "Aujourd'hui".
//
// L'audience était déduite d'une liste d'emails en dur (DEV_SALES_EMAILS),
// ce qui enfermait le fondateur dans la vue dev sans moyen d'en sortir.
// C'est désormais un choix explicite de l'utilisateur, persisté via le
// store ra-core (localStorageStore "CRM", cf root/CRM.tsx). Défaut :
// commercial — le cockpit d'un CRM parle d'abord d'argent et de pipeline.

export const TODAY_AUDIENCE_STORE_KEY = "today.audience";

export const TodayPage = () => {
  const [audience, setAudience] = useStore<DailyBriefAudience>(
    TODAY_AUDIENCE_STORE_KEY,
    "commercial",
  );

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0 flex-1">
          <HomeGreet />
        </div>
        <ToggleGroup
          type="single"
          value={audience}
          onValueChange={(value) =>
            value && setAudience(value as DailyBriefAudience)
          }
          size="sm"
          variant="outline"
          aria-label="Vue du cockpit"
          className="shrink-0 mt-1"
        >
          <ToggleGroupItem value="commercial" className="gap-1.5 text-[12px]">
            <Briefcase className="size-3.5" />
            Commercial
          </ToggleGroupItem>
          <ToggleGroupItem value="dev" className="gap-1.5 text-[12px]">
            <Code className="size-3.5" />
            Dev
          </ToggleGroupItem>
        </ToggleGroup>
      </div>
      <BriefDailyBanner audience={audience} />
      {audience === "dev" ? <TodayDevView /> : <TodayCommercialView />}
    </div>
  );
};

TodayPage.path = "/today";
